"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportReleaseResponseToJSON = exports.ReportReleaseResponseFromJSONTyped = exports.ReportReleaseResponseFromJSON = exports.instanceOfReportReleaseResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ReportReleaseResponse interface.
 */
function instanceOfReportReleaseResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfReportReleaseResponse = instanceOfReportReleaseResponse;
function ReportReleaseResponseFromJSON(json) {
    return ReportReleaseResponseFromJSONTyped(json, false);
}
exports.ReportReleaseResponseFromJSON = ReportReleaseResponseFromJSON;
function ReportReleaseResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'resultsReleasedToPatientDate': !(0, runtime_1.exists)(json, 'results_released_to_patient_date') ? undefined : json['results_released_to_patient_date'],
        'resultsReleasedToPhysicianDate': !(0, runtime_1.exists)(json, 'results_released_to_physician_date') ? undefined : json['results_released_to_physician_date'],
        'scheduledReleaseDate': !(0, runtime_1.exists)(json, 'scheduled_release_date') ? undefined : json['scheduled_release_date'],
        'approvedBy': !(0, runtime_1.exists)(json, 'approved_by') ? undefined : json['approved_by'],
        'patientRequestedResultsDate': !(0, runtime_1.exists)(json, 'patient_requested_results_date') ? undefined : json['patient_requested_results_date'],
        'approvedByPhysicianNetwork': !(0, runtime_1.exists)(json, 'approved_by_physician_network') ? undefined : json['approved_by_physician_network'],
        'needsConfirmation': !(0, runtime_1.exists)(json, 'needs_confirmation') ? undefined : json['needs_confirmation'],
        'shouldBeReleasedThroughGia': !(0, runtime_1.exists)(json, 'should_be_released_through_gia') ? undefined : json['should_be_released_through_gia'],
        'isReportReleased': !(0, runtime_1.exists)(json, 'is_report_released') ? undefined : json['is_report_released'],
        'isFromUs': !(0, runtime_1.exists)(json, 'is_from_us') ? undefined : json['is_from_us'],
        'isReportReleasedToPatient': !(0, runtime_1.exists)(json, 'is_report_released_to_patient') ? undefined : json['is_report_released_to_patient'],
        'isReportReleasedToPhysician': !(0, runtime_1.exists)(json, 'is_report_released_to_physician') ? undefined : json['is_report_released_to_physician'],
        'isReportReleasedToDelegates': !(0, runtime_1.exists)(json, 'is_report_released_to_delegates') ? undefined : json['is_report_released_to_delegates'],
    };
}
exports.ReportReleaseResponseFromJSONTyped = ReportReleaseResponseFromJSONTyped;
function ReportReleaseResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'results_released_to_patient_date': value.resultsReleasedToPatientDate,
        'results_released_to_physician_date': value.resultsReleasedToPhysicianDate,
        'scheduled_release_date': value.scheduledReleaseDate,
        'approved_by': value.approvedBy,
        'patient_requested_results_date': value.patientRequestedResultsDate,
        'approved_by_physician_network': value.approvedByPhysicianNetwork,
        'needs_confirmation': value.needsConfirmation,
        'should_be_released_through_gia': value.shouldBeReleasedThroughGia,
        'is_report_released': value.isReportReleased,
        'is_from_us': value.isFromUs,
        'is_report_released_to_patient': value.isReportReleasedToPatient,
        'is_report_released_to_physician': value.isReportReleasedToPhysician,
        'is_report_released_to_delegates': value.isReportReleasedToDelegates,
    };
}
exports.ReportReleaseResponseToJSON = ReportReleaseResponseToJSON;
